import { gql } from "@apollo/client";

export const CREATE_GROUP = gql`
  mutation CreateGroup($input: GroupDataInput) {
    createGroup(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_GROUP_PAGINATION = gql`
  query GetGroupPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
  ) {
    getGroupPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
    ) {
      data {
        _id
        group_name
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($id: ID, $input: GroupDataInput) {
    updateGroup(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DELETE_GROUP = gql`
  mutation DeleteGroup($id: ID) {
    deleteGroup(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;
